import styled from 'styled-components';

//components
import { BaseButton } from '@/components/Button/BaseButton';

//helpers
import { screen } from '@/helpers/screen';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';

export const PageWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: center;
  width: 100%;
  min-height: 599px;
  text-align: center;

  background-color: rgb(${getToken('color-background-secondary-inverted')});
  background-image: url(/${(props) => props.bg.small});
  background-position: center center;
  background-size: cover;

  padding: 80px 0 50px;

  &.biggerBg {
    min-height: 806px;
  }

  ${screen.md} {
    min-height: 481px;

    background-image: url(/${(props) => props.bg.medium});

    padding: 80px 0 68px;

    &.biggerBg {
      min-height: 678px;

      padding: 80px 0 38px;
    }
  }

  ${screen.lg} {
    min-height: 620px;

    background-image: url(/${(props) => props.bg.large});
  }

  ${screen.xxlg} {
    min-height: 860px;

    background-image: url(/${(props) => props.bg.xxlarge});

    padding: 80px 0 88px;

    &.biggerBg {
      min-height: 866px;
      padding: 100px 0;
    }
  }
`;

export const Title = styled.h1`
  color: rgb(${getToken('color-text-inverted')});
  font-family: ${getToken('platform-font-title')};
  font-weight: ${getToken('font-weight-bold')};
  line-height: 47.5px;
  font-size: 38px;
  width: 100%;
  margin: 16px 0;

  ${screen.md} {
    line-height: 60px;
    font-size: 48px;
  }

  ${screen.lg} {
    margin: 32px 0;
  }
`;

export const Paragraph = styled.p`
  color: rgb(${getToken('color-text-inverted')});
  font-family: ${getToken('platform-font-title')};
  font-weight: ${getToken('font-weight-bold')};
  font-size: 16px;
  line-height: 24px;
  margin: 0 auto 16px;

  ${screen.md} {
    font-size: 20px;
    line-height: 30px;
  }

  ${screen.lg} {
    font-size: 26px;
    line-height: 39px;
    max-width: 895px;
    margin-bottom: 32px;
  }

  ${screen.xxlg} {
    max-width: 981px;
  }
`;
